if (!customElements.get('lus-installation-video')) {
  customElements.define('lus-installation-video', class extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('.lus-installation-player__poster');
      this.poster?.addEventListener('click', event => {
        event.preventDefault();
        this.loadPlayer();
      }, { once: true });
    }

    loadPlayer() {
      const videoId = this.dataset.videoId;
      if (!videoId) return;

      const iframe = document.createElement('iframe');
      iframe.className = 'lus-installation__iframe';
      iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0`;
      iframe.title = this.dataset.videoTitle || 'Installation video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      iframe.setAttribute('webkitallowfullscreen', '');
      this.replaceChildren(iframe);
    }
  });
}
